import { FC } from 'react';
import { Container } from 'react-bootstrap';
import { Button } from '../../atoms';
import { useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';
import styles from './LandscapeProjectsAddProjectsSupportersTemplate.module.css';
import BaseTemplate from '../BaseTemplate';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';
import { LandscapeProjectsAddProjectsGeneralInformationLeadPartnersOrganism } from '../../organisms';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';
import { ProjectOrganizationRelationType } from '../../../store/tradeAPI/projectSupporter/project-organization-relation-type';

interface LandscapeProjectsAddProjectsSupportersTemplateProps {
  data: BuyerResponseDto[];
  handleDelete: (id: string) => void;
}

const LandscapeProjectsAddProjectsSupportersTemplate: FC<
  LandscapeProjectsAddProjectsSupportersTemplateProps
> = ({ data, handleDelete }) => {
  const navigate = useNavigate();
  const { id, projectId } = useParams();
  return (
    <>
      <BaseTemplate>
        <Container>
          <LandscapeEditProjectsAddProjectTemplate>
            <div className={cn(styles.landscapeAboutContactPersonsWrapper)}>
              <div className={cn(styles.button)}>
                <Button
                  variant="dark"
                  onClick={() =>
                    navigate(
                      `/landscapes/edit/${id}/projects/add-project/${projectId}/supporters/add-supporter/${ProjectOrganizationRelationType.Supporters}`
                    )
                  }
                >
                  Add Supporter
                </Button>
              </div>
              <div className={cn(styles.tableWrapper)}>
                <LandscapeProjectsAddProjectsGeneralInformationLeadPartnersOrganism
                  data={data}
                  handleDelete={handleDelete}
                  relationType={ProjectOrganizationRelationType.Supporters}
                />
              </div>
            </div>
          </LandscapeEditProjectsAddProjectTemplate>
        </Container>
      </BaseTemplate>
    </>
  );
};

export default LandscapeProjectsAddProjectsSupportersTemplate;
